/**
 * Site Configuration
 * Central configuration for site branding and URLs
 */

import { API_URL } from './env';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://www.getvitly.com';
const wsEnv = import.meta.env.VITE_WS_URL;
const derivedWsUrl = API_URL.replace(/^http/i, (match) => (match.toLowerCase() === 'https' ? 'wss' : 'ws'));

export const siteConfig = {
  name: import.meta.env.VITE_SITE_NAME || 'Vitly',
  url: siteUrl,
  description: 'The smart way to meet up with friends - plan, discover, and connect in real life.',
  
  // OAuth and auth configuration
  auth: {
    redirectUrl: `${siteUrl}/auth/callback`,
    welcomeUrl: `${siteUrl}/welcome`,
    resetPasswordUrl: `${siteUrl}/reset-password`,
  },

  // Branding
  branding: {
    logoText: 'Vitly',
    tagline: 'The smart way to meet up',
    copyrightName: 'Vitly',
  },

  // Social and contact
  social: {
    twitter: '@getvitly',
    email: 'hello@getvitly.com',
  },

  // API endpoints  
  api: {
    baseUrl: API_URL,
    wsUrl: wsEnv && wsEnv.trim().length > 0 ? wsEnv : derivedWsUrl,
  }
} as const;

export default siteConfig;
